import http from '../utils/http';
import { notifySuccess, notifyError } from './common';
import { Promise as bbPromise } from 'bluebird';

const defaultState = {
    entityName: 'tag',
    baseUrl: 'api/tags/',
    tag: {},
    helpUrl: '/user-guide/guide/tags.html#add-tag'
};

export const mutations = {
    setTag(state, value) {
        if (value) {
            state.tag = value;
        } else {
            state.tag = {};
        }
    }
};

export const actions = {
    fetchTag({ commit, state }, tagId) {
        console.log('calling fetchTag', tagId);
        return http
            .get(`${state.baseUrl}${tagId}`, {
                notifyRequestPending: true
            })
            .then(res => {
                commit('setTag', res.data);
            });
    },
    createTags({ dispatch }, { tags }) {
        console.log('calling createTags');
        const successMessage = 'Tags were added successfully.';
        const failMessage = 'Create tags has failed!';
        dispatch('notifier/requestPending', null, { root: true });
        return bbPromise
            .each(tags, tag => {
                return dispatch('createTag', { tag });
            })
            .then(() => {
                notifySuccess(dispatch, successMessage);
            })
            .catch(error => {
                notifyError(dispatch, failMessage, error);
            })
            .finally(() => {
                dispatch('notifier/reset', null, { root: true });
            });
    },
    createTag({ state }, { tag, notifyConfig }) {
        console.log('calling createTag');
        return http.post(`${state.baseUrl}`, tag, {
            notifyRequestPending: false,
            notifyError: false,
            notifySuccess: false,
            ...notifyConfig
        });
    },
    checkIsTagUnique({ state }, { name, type }) {
        console.log('calling checkIsTagUnique');
        return http
            .get(`${state.baseUrl}search?name=${name}&type=${type}`, {
                notifyRequestPending: true
            })
            .then(res => {
                return res.data.totalElements === 0;
            });
    },
    deleteTag({ state }, { tagId, notifyConfig }) {
        console.log('calling deleteTag', tagId);
        return http.delete(`${state.baseUrl}${tagId}`, null, notifyConfig);
    }
};

export default {
    namespaced: true,
    state: defaultState,
    mutations,
    actions
};
